// React
import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
// Material UI
import { Avatar } from '@material-ui/core'
// Styles
import useStyles from './CustomAvatar.styles'

const getLetterToShow = (error, letter, src) => {
  if (!error && src) {
    return 'das'
  }
  if (!letter) {
    return ''
  }

  return letter.toUpperCase()
}

const CustomAvatar = ({ alt = '', classes, letter, src }) => {
  const componentClasses = useStyles()
  const [error, setError] = useState(false)
  useEffect(() => {
    setError(false)
  }, [src])

  const letterToShow = getLetterToShow(error, letter, src)

  return (
    <div>
      <Avatar
        alt={alt}
        classes={{ root: classNames(componentClasses.root, classes.root) }}
        imgProps={{
          onError: () => {
            setError(true)
          },
        }}
        src={(!error && src) || ''}
      >
        {letterToShow}
      </Avatar>
    </div>
  )
}

CustomAvatar.defaultProps = {
  classes: {},
}

export default CustomAvatar
